import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import FilterComponent from "../Common/FilterComponent";
import DataTable from "react-data-table-component";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { Breadcrumbs, P, H5 } from "../../../AbstractElements";

//DataTable
import { EmpSubDeploymentsTableColumn } from "../../../Data/DataTables/EmployeeSubDeployments";

//Types
import { ViewEmployeeDeployments } from "../../../Types/Employee/EmployeeDeployments";
import { CRUDPermissions } from "../../../Types/Common/Access";

// Modals
import CreateSubDeploymentModal from "../../UiKits/Modal/Employee/CreateSubDeployment";

//Services
import {
  VIEW_EMPDEPLOYMENTS_QUERY_KEY,
  VIEW_EMPDEPLOYMENTS_MAIN_QUERY_KEY,
  employeeDeploymentService,
} from "../../../Services/employeeDeployments";

type DeploymentProps = {
  EmpNo: string;
  isAdmin: boolean;
  access: CRUDPermissions;
};

const SubDeploymentsTable: React.FC<DeploymentProps> = ({
  EmpNo,
  isAdmin,
  access,
}) => {
  const customStyles = {
    rows: {
      style: {
        whiteSpace: "nowrap",
      },
    },
    cells: {
      style: {
        whiteSpace: "nowrap",
        marginTop: "8px",
        marginBottom: "8px",
      },
    },
  };

  const [filterText, setFilterText] = useState("");

  const { data: dataResponse, isLoading: dataisFetching } = useQuery({
    queryKey: [VIEW_EMPDEPLOYMENTS_QUERY_KEY, EmpNo],
    queryFn: () => employeeDeploymentService.ViewByEmployeeNo(String(EmpNo)),
    enabled: !!EmpNo,
  });

  const filteredItems: ViewEmployeeDeployments[] =
    [...(dataResponse ?? [])]
      .filter(
        (item: ViewEmployeeDeployments) =>
          Number(item.is_main) === 0 &&
          Object.values(item).some(
            (value) =>
              value &&
              value.toString().toLowerCase().includes(filterText.toLowerCase()),
          ),
      )
      .sort(
        (a, b) =>
          new Date(b.effectivity_date).getTime() -
            new Date(a.effectivity_date).getTime() || b.id - a.id,
      ) ?? [];

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const columns = EmpSubDeploymentsTableColumn(
    dataResponse?.length ?? 0,
    access,
  );

  return (
    <>
      {access.create && <CreateSubDeploymentModal EmpNo={EmpNo} />}

      <br></br>
      <FilterComponent
        onFilter={(e: React.ChangeEvent<HTMLInputElement>) =>
          setFilterText(e.target.value)
        }
        filterText={filterText}
      />
      <div className="table-responsive">
        <DataTable
          className="display nowrap custom-scrollbar"
          data={filteredItems}
          columns={columns}
          striped={true}
          pagination
          progressPending={dataisFetching}
          highlightOnHover={true}
          fixedHeader={true}
          customStyles={customStyles}
        />
      </div>
    </>
  );
};

export default SubDeploymentsTable;
